import { createSelector } from 'reselect';
import { MetadataSelectors } from 'invision-core';
import { WorkflowStateEnum } from '../../utilities/workflow.state.enum';
var getMappedWorkflowInstances = function getMappedWorkflowInstances(instances, workflowActivityStates) {
  var final = instances;
  Object.keys(instances).forEach(function (key) {
    var instance = instances[key].workflowInstance;
    if (instance && instance.Activities) {
      var activities = instance.Activities.map(function (activity) {
        var activityState = workflowActivityStates.find(function (code) {
          return code.Value === String(activity.CurrentState);
        });
        return activity.merge({
          activityState: WorkflowStateEnum[activity.CurrentState],
          activityStateName: activityState.Name,
          activityStateDescription: activityState.Description
        }, {
          deep: true
        });
      });
      var mappedInstance = instance.set('activities', activities);
      final = final.setIn([key, 'workflowInstance'], mappedInstance);
    }
  });
  return final;
};
var WorkflowSelector = function WorkflowSelector(state) {
  return state.customercare.workflow.data;
};
export var WorkflowActivityItemsSelector = createSelector([WorkflowSelector, MetadataSelectors.codes.WorkflowActivityStateSelector], function (workflowInstances, workflowActivityStates) {
  return workflowActivityStates.length ? getMappedWorkflowInstances(workflowInstances, workflowActivityStates).asMutable({
    deep: true
  }) : null;
});